export default __webpack_public_path__ + "static/media/funds.a3252a82.svg";